import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-form-question-container',
    templateUrl: './form-question-container.component.html',
    styleUrls: ['./form-question-container.component.scss'],
    standalone: false
})
export class FormQuestionContainerComponent {
    @Input() public name: string;
    @Input() public questionId: number;
    @Input() public tooltip: string = null;

    constructor() { }
}
